import { Component, ViewChild, OnInit, Input } from '@angular/core'
import { Router } from '@angular/router'

import { jqxTreeGridComponent } from 'jqwidgets-ng/jqxtreegrid'

import { OrgModel } from '../../models/org-model'

export interface GridLabels {
    name: string
    type: string | number
}

export interface ColumnsLabels {
    text: string
    dataField: string
    width: number
    cellsFormat?: any
}

@Component({
    selector: 'OrgHierarchy',
    templateUrl: `OrgHierarchy.component.html`
})
export class OrgHierarchy implements OnInit {
    @ViewChild('TreeGrid', { static: true }) treeGrid: jqxTreeGridComponent
    jqx: any
    viewModel: OrgModel[]
    @Input() org: any = []
    @Input() dataFields: GridLabels[]
    @Input() key: any
    @Input() parent: any
    @Input() columnsLabel: ColumnsLabels[]
    orgId: number
    source: any = {
        dataFields: [
            { name: 'CurrentOrgID', type: 'number' },
            { name: 'CurrentOrgParentOrgID', type: 'number' },
            { name: 'CurrentOrgIDShortName', type: 'string' },
            { name: 'CurrentOrgIDName', type: 'string' },
            { name: 'CUID', type: 'number' },
            { name: 'OrgName', type: 'string' },
            { name: 'IsActive', type: 'boolean' }
        ],
        hierarchy: {
            keyDataField: { name: 'CurrentOrgID' },
            parentDataField: { name: 'CurrentOrgParentOrgID' }
        },
        dataType: 'json',
        id: 'OrgID',
        localData: this.org
    }
    dataAdapter = new jqx.dataAdapter(this.source)

    columns = [
        { text: 'OrgShortName', dataField: 'CurrentOrgIDShortName', width: 180 },
        { text: 'OrgName', dataField: 'CurrentOrgIDName', width: 460 },
        { text: 'CUID', dataField: 'CUID', width: 180 },
        { text: 'Active', dataField: 'IsActive', width: 180 },
        {
            text: 'Edit',
            cellsAlign: 'center',
            align: 'center',
            columnType: 'none',
            width: 120,
            editable: false,
            sortable: false,
            dataField: null,
            cellsRenderer: (row: number, column: any, value: any): string => {
                return `<div data-row='` + row + `' class='editButton' style='margin-left: 2em;'></div>`
            }
        }
    ]

    ready(): void {
        this.treeGrid.expandRow(2)
    }

    rendered = (): void => {
        let uglyEditButtons = jqwidgets.createInstance('.editButton', 'jqxButton', { width: 60, height: 24, value: 'Edit' })
    }
    public onDataLoad(org: any[]): void {
        // update databound
        this.source.localdata = org
        this.dataAdapter.dataBind()
        this.treeGrid.updateBoundData()
        let uglyEditButtons = jqwidgets.createInstance('.editButton', 'jqxButton', { width: 60, height: 24, value: 'Edit' })
    }

    rowClick(event: any): void {
        if (event.owner.clickedTD.innerText.trim() === 'Edit') {
            this.orgId = event.args.row.CurrentOrgID
            this._route.navigate(['organizations/edit/' + this.orgId])
        }
    }

    constructor(private _route: Router) {}

    ngOnInit(): void {}
}
